/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Report_Status_Not_CompletedInputs */

const es_co2_error_report_status_not_completed = /** @type {(inputs: Error_Report_Status_Not_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El reporte debe estar completo para finalizarse.`)
};

/**

* @param {Error_Report_Status_Not_CompletedInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_report_status_not_completed = /** @type {((inputs?: Error_Report_Status_Not_CompletedInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Report_Status_Not_CompletedInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_report_status_not_completed(inputs)
});